import { useContext } from 'react';

import { LoaderContextProps } from '../contexts/loader/types';
import { LoaderContext } from './../contexts/loader/provider';

export function useLoader(): LoaderContextProps {
    return useContext(LoaderContext);
}
